import React from "react";
import { observer } from "mobx-react";
import { EditionTypeViewStore } from "../../store";
import { EditionTypeViewForm } from "./EditionTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EditionTypeViewProps = {
  editionTypeViewStore: EditionTypeViewStore;
};

export const EditionTypeView: React.FC<EditionTypeViewProps> = observer(
  ({ editionTypeViewStore }) => {
    return (
      <div>
        <EditionTypeViewForm
          name_es={editionTypeViewStore.name_esValue}
          name_en={editionTypeViewStore.name_enValue}
          name_pt={editionTypeViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            editionTypeViewStore.printEditionType(handlePrint)
          }
          onCancel={() => editionTypeViewStore.cancelEditionType()}
          onEdit={
            editionTypeViewStore.isEditEnabled
              ? () => editionTypeViewStore.editEditionType()
              : undefined
          }
        />
        <ErrorDialog
          open={editionTypeViewStore.errorDialogOpened}
          title={editionTypeViewStore.errorTitle}
          description={editionTypeViewStore.errorDescription}
          onClose={() => editionTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
